import React from 'react';
import { format, parseISO } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logComponent from '../../common/logComponent';

export default function NotesHistoryRow({ note, selected, user, onClick }) {
  if (logComponent('NotesHistoryRow')) { console.debug('NotesHistoryRow rendered'); }

  const handleClick = () => {
    if (logComponent('NotesHistoryRow')) { console.debug('NotesHistoryRow handleClick'); }
    if (onClick) onClick(note);
  }


    return (
      <li 
        key={note.id}
        tabIndex={0}
        className={ 'Notes-History__note-list-item' + ( selected ? ' Notes-History__note-list-item--selected' : '') +  (user.groupTypeString === 'Facility' ? ' three-column' : ' two-column') }
        onClick={handleClick}>
        <p>{note.userDisplayName }</p>
        <p className="Notes-History__note-date">
          <span>{format(parseISO(note.noteOn), 'MMMM dd, yyyy') }</span>
          <span>{format(parseISO(note.noteOn), 'h:mm aaa') }</span> 
        </p>
        {
          user.groupTypeString === 'Facility' &&
          <p className="Notes-History__visibility">
            <FontAwesomeIcon icon="circle" size="sm" className={`Notes-History__visibility-icon--${note.type.toLowerCase()}`} />
            <span className="Notes-History__visibility-text">{ note.type === 'Family' ? 'Family' : 'Internal' } </span>
          </p>
        }
        
    </li>
    );
}